<template>
  <div class="j-mavon-editor">
    <mavon-editor
      ref="md"
      v-model="myValue"
      :toolbars="toolbars"
      :editable="editable"
      :subfield="subfield"
      :defaultOpen="defaultOpen"
      @imgAdd="imgAdd"
      @imgDel="imgDel"
      @change="change"
      @save="save"
    />
  </div>
</template>

<script>
import { getAction, uploadAction } from "@/api/manage";
const uuidGenerator = () => {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'
  var uuid = s.join('')
  return uuid
}
export default {
  name: "JMavonEditor",
  components: {},
  data() {
    return {
      myValue: this.value,
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        mark: true, // 标记
        superscript: true, // 上角标
        quote: true, // 引用
        ol: true, // 有序列表
        link: true, // 链接
        imagelink: true, // 图片链接
        help: true, // 帮助
        code: true, // code
        subfield: true, // 是否需要分栏
        fullscreen: true, // 全屏编辑
        readmodel: true, // 沉浸式阅读
        /* 1.3.5 */
        undo: true, // 上一步
        trash: true, // 清空
        save: false, // 保存（触发events中的save事件）
        /* 1.4.2 */
        navigation: true, // 导航目录
         /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        preview: true, // 预览
      },
      uploadAction: {
        local: window._CONFIG["domianURL"] + "/sys/common/upload",
        qiniu: "//upload-" + this.$store.getters.tenantInfo.qiniuArea + ".qiniup.com",
        oss: "",
        cos: "",
      },
      tokenAction: {
        qiniu: "/common/qiniu/getToken",
      },
      downloadUrl: {
          local: this.$store.getters.tenantInfo.staticDomain + '/',
          qiniu: this.$store.getters.tenantInfo.qiniuDomain + '/'
      },
    };
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false,
    },
    //是否允许编辑
    editable: {
      type: Boolean,
      default: true,
      required: false,
    },
    //双栏
    subfield: {
      type: Boolean,
      default: true,
      required: false,
    },
    //默认展示编辑区域 edit preview
    defaultOpen: {
      type: String,
      required: false,
      default: "preview",
    },
  },
  watch: {
    value(newValue) {
      this.myValue = newValue == null ? "" : newValue;
    },
    myValue(newValue) {
      if (this.triggerChange) {
        this.$emit("change", newValue);
      } else {
        this.$emit("input", newValue);
      }
    },
  },
  created() {},
  methods: {
    imgAdd(pos, file) {
      let that = this;
      getAction(that.tokenAction.qiniu, {}).then((token_res) => {
        if (token_res.success) {
          let formData = new FormData();
          formData.append("file", file, uuidGenerator() + file.name);
          formData.append("token", token_res.result);
          formData.append("key", uuidGenerator() + file.name);
          uploadAction(
            that.uploadAction.qiniu,
            formData,
            function (progressEvent) {
              let complete =
                ((progressEvent.loaded / progressEvent.total) * 100) | 0;
              console.log(complete);
            }
          )
            .then((res) => {
              let url = that.downloadUrl.qiniu + res.key;
              console.log(url);
              this.$refs.md.$img2Url(pos, url);
            })
            .catch(() => {});
        } else {
          that.$message.error(token_res.message);
        }
      });
    },
    imgDel(filename) {},
    save(value, render) {
      console.log(value);
      console.log(render);
    },
    change(value, render) {},
    clear() {
      this.myValue = "";
    },
  },
};
</script>

<style scoped>
</style>